var _g, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconGeolocalization = function SvgIconGeolocalization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_9904",
    "data-name": "Grupo 9904",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7059",
    "data-name": "Grupo 7059",
    transform: "translate(8.901 8.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7058",
    "data-name": "Grupo 7058",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3885",
    "data-name": "Caminho 3885",
    d: "M168.147-401.506a3.1,3.1,0,0,0-3.1,3.1,3.1,3.1,0,0,0,3.1,3.1,3.1,3.1,0,0,0,3.1-3.1A3.1,3.1,0,0,0,168.147-401.506Z",
    transform: "translate(-165.048 401.506)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3886",
    "data-name": "Caminho 3886",
    d: "M12.872-565.683h-.985a9.945,9.945,0,0,0-2.854-5.905,9.945,9.945,0,0,0-5.905-2.854v-.985A1.129,1.129,0,0,0,2-576.555a1.129,1.129,0,0,0-1.128,1.128v.985a9.945,9.945,0,0,0-5.905,2.854,9.945,9.945,0,0,0-2.854,5.905h-.985A1.129,1.129,0,0,0-10-564.555a1.129,1.129,0,0,0,1.128,1.128h.985a9.945,9.945,0,0,0,2.854,5.906,9.945,9.945,0,0,0,5.905,2.854v.985A1.129,1.129,0,0,0,2-552.555a1.129,1.129,0,0,0,1.128-1.128v-.985a9.945,9.945,0,0,0,5.905-2.854,9.945,9.945,0,0,0,2.854-5.906h.985A1.129,1.129,0,0,0,14-564.555,1.129,1.129,0,0,0,12.872-565.683ZM7.99-564.555a1.129,1.129,0,0,0,1.128,1.128h.495a7.7,7.7,0,0,1-2.174,4.311,7.7,7.7,0,0,1-4.311,2.174v-.495A1.129,1.129,0,0,0,2-558.565a1.129,1.129,0,0,0-1.128,1.128v.495a7.7,7.7,0,0,1-4.311-2.174,7.7,7.7,0,0,1-2.174-4.311h.837a1.129,1.129,0,0,0,1.128-1.128,1.129,1.129,0,0,0-1.128-1.128h-.837a7.7,7.7,0,0,1,2.174-4.311,7.7,7.7,0,0,1,4.311-2.174v.495A1.129,1.129,0,0,0,2-570.545a1.129,1.129,0,0,0,1.128-1.128v-.495a7.7,7.7,0,0,1,4.311,2.174,7.7,7.7,0,0,1,2.174,4.311H9.118A1.129,1.129,0,0,0,7.99-564.555Z",
    transform: "translate(10 576.555)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGeolocalization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_geolocalization.39ae3141.svg";
export { ForwardRef as ReactComponent };